<template>
  <el-popover placement="top-end" trigger="hover" popper-class="reset-alipay-accounts" width="300px">
    <template #reference>
      <el-button type="primary" size="small" :loading="loading" :disabled="disabled" @click="resetTime">{{ remainText }}</el-button>
    </template>
    <template #default>
      <span v-if="remainTime">在 <span style="color: red">{{remainTime}}秒</span> 后可再点击按钮，刷新支付宝收款账号下拉选项</span>
      <span v-else>在下方【链接】添加/修改支付宝收款账号后，点击按钮可刷新支付宝收款账号下拉选项</span>
    </template>
  </el-popover>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { getUrlParams } from '@/common/js/utils'
import _ from 'lodash'
export default {
  name: 'ResetAlipayAccounts',
  data () {
    const params = getUrlParams()
    return {
      loading: false,
      storageKey: `ResetAlipayAccounts_${params.foId}`,
      resetTime: _.debounce(() => {
        this.loading = true
        this.initAlipayAccounts(() => {
          this.loading = false
          this.$alert('已更新支付宝收款账号下拉选项列表，60秒后可再次刷新', '提示', {
            type: 'success'
          })
          localStorage.setItem(this.storageKey, this.now + 6e4)
        })
      })
    }
  },
  computed: {
    ...mapGetters('dateStore', ['now']),
    remainTime () {
      const targetTime = localStorage.getItem(this.storageKey) || 0
      const { now } = this
      return Math.ceil(Math.max(targetTime - now, 0) / 1000)
    },
    remainText () {
      const { remainTime } = this
      return remainTime ? `${remainTime}s` : '刷新'
    },
    disabled () {
      return !!this.remainTime
    },
    hoverContent () {
      const { remainTime } = this
      return remainTime ? `在${remainTime}秒后可再点击按钮，刷新支付宝收款账号下拉选项` : '在下方【链接】添加/修改支付宝收款账号后，点击按钮可刷新支付宝收款账号下拉选项'
    }
  },
  mounted() {
    this.run()
  },
  methods: {
    ...mapActions('dateStore', ['run']),
    ...mapActions(['initAlipayAccounts'])
  }
}
</script>
<style lang="scss" scoped>
.reset-alipay-accounts{
  font-size: 14px;
  line-height: 25px;
}  
</style>